import Axios from "axios";
import React, { useEffect, useState } from "react";
//import RandomNumberInRange from "./RandomNumberInRange";
import QuestionsRetrievedInForm from "./QuestionsRetrievedInForm";

const QuestionsRetrieval = () => {

    // Fetch data from API using the Axios library
    // Remember Axios needs to be installed : npm install axios
    const [question, setQuestion] = useState({
        loading: false,
        repos: null,
    });

    useEffect(() => {
        setQuestion({ loading: true });
        //Axios.get("http://localhost/richard_xampp/server/api/get_questions.php")
        Axios.get("https://www.todaysminicrossword.com/server/api/get_questions.php")
          .then((repos) => {
            // Random questions if you want
            //const size = repos.data.length;
            //const chosenQuestionNum = RandomNumberInRange(0, size - 1);
            const chosenQuestionNum = 9;
            const chosenQuestion = repos.data[chosenQuestionNum];
            setQuestion({ loading: false, repos: chosenQuestion });
          })
          .catch((error) => {
            console.log(error);
          });
      }, [setQuestion]);

return (
    <React.Fragment>
      <QuestionsRetrievedInForm
        isLoading={question.loading}
        repos={question.repos}
      />
    </React.Fragment>
  );
};

export default QuestionsRetrieval;